import { ifAuthenticated } from '@/router/before'

export const adminRouteNames = {
  SettingsRoute: 'SettingsRoute',
  ServerLogsRoute: 'ServerLogsRoute',
  SessionsRoute: 'SessionsRoute',
  HistoryRoute: 'HistoryRoute',
  BuildInfoRoute: 'BuildInfoRoute',
  UserPermissionsRoute: 'UserPermissionsRoute'
}
const rn = adminRouteNames

export const adminRouteURLs = {
  [rn.SettingsRoute]: '/admin/settings',
  [rn.ServerLogsRoute]: '/admin/logs',
  [rn.SessionsRoute]: '/admin/sessions',
  [rn.HistoryRoute]: '/admin/history',
  [rn.BuildInfoRoute]: '/admin/build',
  [rn.UserPermissionsRoute]: '/admin/users'
}

export const adminPages = [
  {
    path: adminRouteURLs[rn.ServerLogsRoute],
    name: rn.ServerLogsRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'satellite-dish'],
        isDisplay: true
      },
      navbar: {
        group: 'Администрирование',
        displayName: 'Логи сервера'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "ServerLogsRoute" */ '@/views/admin/ServerLogsRoute.vue'
      )
  },
  {
    path: adminRouteURLs[rn.SessionsRoute],
    name: rn.SessionsRoute,
    meta: {
      sidebar: {
        icon: ['fas', 'binoculars'],
        isDisplay: true
      },
      navbar: {
        group: 'Администрирование',
        displayName: 'Активные сессии'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "SessionsRoute" */ '@/views/admin/SessionsRoute.vue'
      )
  },
  {
    path: adminRouteURLs[rn.HistoryRoute],
    name: rn.HistoryRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'history'],
        isDisplay: true
      },
      navbar: {
        group: 'Администрирование',
        displayName: 'История изменений'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "HistoryRoute" */ '@/views/admin/HistoryRoute.vue'
      )
  },
  {
    path: adminRouteURLs[rn.BuildInfoRoute],
    name: rn.BuildInfoRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'cog'],
        isDisplay: true
      },
      navbar: {
        group: 'Администрирование',
        displayName: 'Обслуживание системы'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "BuildInfoRoute" */ '@/views/admin/BuildInfoRoute.vue'
      )
  },
  {
    path: adminRouteURLs[rn.UserPermissionsRoute],
    name: rn.UserPermissionsRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'user'],
        isDisplay: true
      },
      navbar: {
        group: 'Администрирование',
        displayName: 'Назначение прав и ролей'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "UserPermissionsRoute" */ '@/views/admin/UserPermissionsRoute.vue'
      )
  },
  {
    path: adminRouteURLs[rn.SettingsRoute],
    name: rn.SettingsRoute,
    meta: {
      sidebar: {
        icon: ['fa', 'cogs'],
        isDisplay: true
      },
      navbar: {
        group: 'Администрирование',
        displayName: 'Настройки системы'
      }
    },
    beforeEnter: ifAuthenticated,
    component: () =>
      import(
        /* webpackChunkName: "Settings" */ '@/views/admin/SettingsRoute.vue'
      )
  }
]
